:host {
  display: block;
  width: 100%;

  --_omk-tabs-scrollable-padding: var(--omk-tabs-scrollable-padding, var(--omk-dimension-units-13));
}

md-tabs {
  overflow-x: auto;
  cursor: pointer;

  &.scrollable {
    ::slotted(omk-tab:first-child) {
      padding-left: var(--_omk-tabs-scrollable-padding);
    }

    ::slotted(omk-tab:last-child) {
      padding-right: var(--_omk-tabs-scrollable-padding);
    }
  }
}
